import { call, put, takeLatest, select } from 'redux-saga/effects';
import apiService from '../../api/service/apiService';
import ENDPOINTS from '../../api/endPoints';
import {
  fetchCampaignPostsAnalyticsRequest,
  fetchCampaignPostsAnalyticsSuccess,
  fetchCampaignPostsAnalyticsFailure,
} from '../slices/campaignPostsAnalyticsSlice';
import type { CampaignWithAnalytics } from '../slices/campaignPostsAnalyticsSlice';
import type { RootState } from '../store';

function* fetchCampaignPostsAnalyticsSaga(): Generator<any, void, any> {
  try {
    const restaurantId: string = yield select((state: RootState) => state.clover.restaurantId);
    const response = yield call(apiService.get, {
      endpoint: ENDPOINTS.analytics,
      headers: {
        'restaurant-id': restaurantId,
      },
    });
    
    const campaignsData: CampaignWithAnalytics[] = response.data?.data?.saved || response.data?.saved || [];
    yield put(fetchCampaignPostsAnalyticsSuccess(campaignsData));
  } catch (error: any) {
    const errorMessage = error?.message || 'Failed to fetch campaign posts analytics';
    yield put(fetchCampaignPostsAnalyticsFailure(errorMessage));
  }
}

export default function* campaignPostsAnalyticsSagaWatcher() {
  yield takeLatest(fetchCampaignPostsAnalyticsRequest.type, fetchCampaignPostsAnalyticsSaga);
}
